import { SIGNOUT_REQUEST } from '../action/authActions'

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case SIGNOUT_REQUEST:
            return initialState;
        default:
            return state;
    }
};

export default AuthReducer;